import React, { useLayoutEffect } from 'react';
import {
  Box,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { PASSWORD_TO_QR_KEY } from '../../common/passwordToQrTransfer';
import { sendEvent } from '../../common/analytics';
import { qrCodeStore } from './stores/qrCodeStore';
import QrWorkspace from './components/QrWorkspace';

const QrCode = observer(() => {
  const subColor = useColorModeValue('gray.500', 'gray.400');

  useLayoutEffect(() => {
    try {
      const raw = sessionStorage.getItem(PASSWORD_TO_QR_KEY);
      if (!raw) return;
      sessionStorage.removeItem(PASSWORD_TO_QR_KEY);
      const parsed = JSON.parse(raw);
      const text = typeof parsed?.text === 'string' ? parsed.text : '';
      if (!text) return;
      qrCodeStore.setQrType('text');
      qrCodeStore.setFormData('text', text);
      qrCodeStore.generate();
      sendEvent('QrCode', 'Import', 'from-password-generator');
    } catch (_) {
      /* ignore */
    }
  }, []);

  return (
    <Box>
      <Box mb={5}>
        <Heading as="h1" size="md" fontWeight="600" mb={0.5}>
          QR Code Generator
        </Heading>
        <Text fontSize="sm" color={subColor}>
          Type, paste, or fill in your content — QR updates live
        </Text>
      </Box>

      <QrWorkspace store={qrCodeStore} />
    </Box>
  );
});

export default QrCode;
